import _ from 'lodash';
import React from 'react';
import update from 'immutability-helper';
import PropTypes from 'prop-types';
import moment from 'moment';
import toastr from 'toastr';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import { getContact, sendContact as send } from '../../../services/lwadmin/partnership/partnership-service';

const Contact = source => ({
  ...(source || {
    id: null,
    name: '',
    email: '',
    phone: '',
    investor_type: '',
    enquiring_about: [],
    message_to_contributor: '',
    partnership: {
      id: null,
    },
  }),
  created_at: _.get(source, 'created_at') ? moment(source.created_at) : null,
  sent_at: _.get(source, 'sent_at') ? moment(source.sent_at) : null,
});

export default class ViewContactModal extends React.Component {
  static propTypes = {
    contactWasSent: PropTypes.func,
  };

  static defaultProps = {
    contactWasSent: null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      contact: Contact(),
    };
  }

  componentDidMount() {
    const self = this;

    this.$modal.click(function onClick(e) {
      if (e.target === this) self.dismiss();
    });
  }

  present(partnershipId, contactId) {
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
    this.loading.start();
    getContact(partnershipId, contactId)
      .then(result => this.setState({ contact: Contact(result.data) }))
      .catch(error => defaultOnErrorHandler(error, 'Error loading contact'))
      .finally(() => this.loading.stop());
  }

  dismiss() {
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
  }

  sendContact() {
    this.loading.start();
    send(this.state.contact.partnership.id, this.state.contact.id)
      .then(() => {
        this.setState(state => update(state, {
          contact: {
            sent_at: { $set: moment() },
          },
        }));
        toastr.success('Contact has been sent');
        this.props.contactWasSent && this.props.contactWasSent();
      })
      .catch(error => defaultOnErrorHandler(error, 'Error sending contact'))
      .finally(() => this.loading.stop());
  }

  render() {
    const { contact } = this.state;
    return (
      <div>
        <div className="modal-overlay" role="region" ref={el => (this.$overlay = $(el))} onClick={() => this.dismiss()} />
        <div className="modal --large" tabIndex="-1" role="dialog" ref={el => (this.$modal = $(el))}>
          <article>
            <header>
              <h4>
                {`Contact from ${contact.name} - ${contact.sent_at ? contact.sent_at.format('LLLL') : 'Not sent'}`}
              </h4>
            </header>
            <Loading ref={c => (this.loading = c)}>
              <pre className="--email-preview">
                {contact.wire && (
                  <p>
                    {`You have received a contact/lead from ${contact.wire.profile.name}'s wire `}
                    <a href={`/wires/${contact.wire.slug}`}>
                      {`"${contact.wire.title}"`}
                    </a>
                    .
                  </p>
                )}
                {contact.profile && (
                  <p>
                    {'You have received a contact/lead from '}
                    <a href={`/contributors/${contact.profile.slug}`}>
                      {`${contact.profile.name}`}
                    </a>
                    {' page.'}
                  </p>
                )}
                {contact.fund && (
                  <p>
                    {'You have received a contact/lead from '}
                    <a href={`/funds/${contact.fund.slug}`}>
                      {`${contact.fund.name}`}
                    </a>
                    {' page.'}
                  </p>
                )}
                <p>
                  <strong>Name:</strong>
                  {` ${contact.name}`}
                </p>
                <p>
                  <strong>Email:</strong>
                  {`${contact.email}`}
                </p>
                <p>
                  <strong>Phone number:</strong>
                  {`${contact.phone}`}
                </p>
                <p>
                  <strong>Investor type:</strong>
                  {`${contact.investor_type}`}
                </p>
                <p><strong>Enquiring about:</strong></p>
                <ul>
                  {contact.enquiring_about.map(topic => <li key={topic}>{topic}</li>)}
                </ul>
                <p><strong>Message:</strong></p>
                <p>{contact.message_to_contributor}</p>
              </pre>
              <footer>
                {!contact.sent_at && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => this.sendContact()}
                  >
                    Send now
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.dismiss()}
                >
                  Close
                </button>
              </footer>
            </Loading>
          </article>
        </div>
      </div>
    );
  }
}
